import { isEmpty, isString } from 'lodash';
import clsx from 'clsx';
import type { FC } from 'react';
import type { StructuredText as StructuredTextType } from 'datocms-structured-text-utils';

import { BaseBlock } from '@/components/base-block';
import { getModelURL } from '@/lib/datocms/utils/get-model-url';
import { isStructuredText } from '@/lib/datocms/utils/is-structured-text';
import { isStructuredTextEmpty } from '@/lib/datocms/utils/is-structured-text-empty';
import { Link } from '@/components/link';
import { StructuredText } from '@/components/structured-text';
import type { CtaBlockType } from '@/lib/types';
import { ctaBlock, ctaBlockAffix } from './styles.css';

type CtaBlockProps = CtaBlockType & { className?: string | null };

const hasAffix = (field: StructuredTextType | string | null) => {
  if (isString(field) && !isEmpty(field)) {
    return true;
  }

  if (isStructuredText(field) && !isStructuredTextEmpty(field)) {
    return true;
  }

  return false;
};

const CtaBlock: FC<CtaBlockProps> = ({
  className,
  layout,
  link,
  linkText,
  prefixContent,
  suffixContent,
  theme,
  anchor,
}) => {
  const hasPrefix = hasAffix(prefixContent);
  const hasSuffix = hasAffix(suffixContent);

  return (
    <BaseBlock className={clsx(ctaBlock, className)} theme={theme} anchor={anchor}>
      {hasPrefix && (
        <div className={`${ctaBlockAffix} mb-3`}>
          {isStructuredText(prefixContent) ? <StructuredText data={prefixContent} /> : <p>{prefixContent}</p>}
        </div>
      )}
      {!isEmpty(link) && !isEmpty(linkText) && (
        <Link
          // Primary CTA use action (red) btn
          className={clsx('btn btn-lg', `btn-${layout === 'Primary' ? 'goal' : 'primary'}`)}
          href={getModelURL(link)}
          analytics={{ context: 'CTA - CTA Module', text: linkText }}
        >
          {linkText}
        </Link>
      )}
      {hasSuffix && (
        <div className={`${ctaBlockAffix}  mt-3`}>
          {isStructuredText(suffixContent) ? <StructuredText data={suffixContent} /> : <p>{suffixContent}</p>}
        </div>
      )}
    </BaseBlock>
  );
};

export { CtaBlock };
